var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('div',{attrs:{"id":"arrow-div"},on:{"click":_vm.backOnePage}},[_c('img',{attrs:{"id":"left-arrow","src":require("@/assets/leftarrow.png")}})]),_vm._v(" "),_c('div',{class:{ 'displayoff':  _vm.loaded },attrs:{"id":"loading"}},[_c('vk-spinner',{attrs:{"ratio":"2.0"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0dad552","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ThreeScene.vue
// module id = null
// module chunks = 